module.exports = __webpack_public_path__ + "img/default_avatar_female_preview.978cd10a.png";